import { render, staticRenderFns } from "./CustomPermissionList.vue?vue&type=template&id=1e0568e9&"
import script from "./CustomPermissionList.vue?vue&type=script&lang=js&"
export * from "./CustomPermissionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports